import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useMutationResourceTitleRename } from '../../../mutations/useMutationResourceTitleRename.js';
import { useQueryUserInfo } from '../../../../user/queries/useQueryUserInfo.js';
import { ResourceTitleEditable } from '../../ResourceTitle/ResourceTitleEditable.js';
import { useInputControls } from '@fabric-app/hooks/useInputControls';
import { useResourceDataContextSafe } from '../../context/resourceDataContext.js';
import { useExpandedFdocContext } from '../../ExpandedFdoc/ExpandedFdocProvider.js';
import { forwardRef, useImperativeHandle, useEffect } from 'react';

const NewModalWrapper = styled.div.withConfig({
  displayName: "ResourceTitle__NewModalWrapper",
  componentId: "sc-4d540e75-0"
})([
  `overflow-x:hidden;height:100%;display:flex;align-items:center;& > *{margin-left:0;}`
]);
const ExpandedResourceTitle = /* @__PURE__ */ forwardRef(({ onTitleChange }, ref) => {
  const { resource, disabledActions, isRenameable } = useResourceDataContextSafe();
  const resourceTitle = resource?.name || "";
  const { setIsEditorFocused, isEditorFocused } = useExpandedFdocContext();
  const { mutate: mutateResourceTitleRename } = useMutationResourceTitleRename();
  const { data: user } = useQueryUserInfo();
  const isTitleEditable = isRenameable && !disabledActions.modify;
  const titleInput = useInputControls(resourceTitle, {
    shouldUpdateStateOnDefaultValueChange: () => !isEditorFocused
  });
  useImperativeHandle(ref, () => {
    return {
      setTitle: (title) => {
        console.log("setTitle", title);
        titleInput.onChange(title);
      }
    };
  });
  useEffect(() => {
    onTitleChange?.(titleInput.value);
  }, [
    titleInput.value,
    onTitleChange
  ]);
  return /* @__PURE__ */ jsx(NewModalWrapper, {
    children: /* @__PURE__ */ jsx(ResourceTitleEditable, {
      titleInput,
      resourceUrl: resource.originUrl,
      setIsEditorFocused,
      onSubmit: (value) => {
        if (!resource || resource.isDraft) {
          return;
        }
        if (isTitleEditable && resourceTitle !== value && !!resource) {
          mutateResourceTitleRename({
            resource: {
              id: resource.id,
              kind: resource.kind
            },
            newTitle: value
          });
        }
      },
      readOnly: !isTitleEditable,
      user: user ?? null
    })
  });
});
ExpandedResourceTitle.displayName = "ExpandedResourceTitle";

export { ExpandedResourceTitle };
//# sourceMappingURL=ResourceTitle.js.map
